import { createFileRoute } from '@tanstack/react-router'

import { HomeContentContainer } from '@/components'
import { OverallDashboard } from '@/components/pages/Admin/Dashboard/Overall'

export const Route = createFileRoute('/(dashboard)/admin/')({
  component: AdminPage,
})

function AdminPage() {
  return (
    <HomeContentContainer title={'ภาพรวม'} subtitle={'สรุปยอดตามวันที่บิลและสถานที่'}>
      <OverallDashboard />
    </HomeContentContainer>
  )
}
